import {
  Box,
  Grid,
  Stack,
  Typography,
  styled,
  keyframes,
  Button,
} from "@mui/material";
import React from "react";
import CounterBox from "../CounterBox";
import { LayoutContainer } from "../app-layoout/container";
import Image from "../image/image";

const StyledWrapperStack = styled(Stack)(({ theme }) => ({
  position: "relative",
  height: "100%",
  ":before": {
    content: "url(/assets/home/Image.png)",
    right: 0,
    top: "76px",
    zIndex: 0,
    position: "absolute",
    background: theme.palette.grey[900],
  },

  [theme.breakpoints.down("sm")]: {
    ":before": {
      display: "none",
    },
  },
}));

const rotateAnimation = keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  `;

const StyledRoundBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  left: "47%",
  top: "30%",
  animation: `${rotateAnimation} 10s linear infinite`,
  [theme.breakpoints.down("md")]: {
    width: "110px",
    top: "29%",
    left: "0%",
    display: "none",
  },
  [theme.breakpoints.down("sm")]: {
    width: "110px",
    top: "26%",
    left: "65%",
    display: "block",
  },
}));

const VisitSection = () => {
  return (
    <StyledWrapperStack>
      <LayoutContainer>
        <Grid
          container
          pt="40px"
          pb={{ xs: "20px", xl: "256px" }}
          sx={{ position: "relative", zIndex: 5 }}
        >
          <Grid item xs={12} md={6} pt={{ xs: "40px", md: "180px" }}>
            <Box display={{ xs: "block", sm: "none", md: "none" }} mb={3}>
              <Image src="/assets/home/Image-mobile.png" />
            </Box>
            <StyledRoundBox>
              <Box
                component="img"
                src="/assets/home/round-text.svg"
                width="100%"
              />
            </StyledRoundBox>
            <Stack direction="column" mb={{ xs: 7, sm: 2, md: 7  }} mt={{ xs: 0, sm: 7, md: 0  }}>
              <Typography variant="h1" mb={2} color="text.secondary">
                Desarrollo inmobiliario Plusvalica
                <br />
              </Typography>
              <Typography variant="h4" color="text.secondary" width="85%">
                El sueño del activo digital SOIL hecho realidad
              </Typography>
            </Stack>

            <Stack
              direction={{ xs: "column", md: "row" }}
              gap={2}
              mb={7}
              pt={{ xs: 0, sm: 12, md: 0 }}
              width={{ xs: "100%", md: "100%", lg: "80%" }}
            >
              <Button
                variant="contained"
                href="/propiedades"
                size="large"
                sx={{
                  backgroundColor: "#a95052",
                  "&:hover": { backgroundColor: "#8c3e47" },
                }}
              >
                Explorar Propiedades
              </Button>
              <Button
                variant="contained"
                href="/registra-tu-propiedad"
                size="large"
                sx={{
                  backgroundColor: "#a95052",
                  "&:hover": { backgroundColor: "#8c3e47" },
                }}
              >
                Registra tu Propiedad
              </Button>
            </Stack>
            <CounterBox />
          </Grid>
          <Grid item xs={12} md={6} position="relative"></Grid>
        </Grid>
      </LayoutContainer>
    </StyledWrapperStack>
  );
};

export default VisitSection;
